<template>
  <div>

    <TermsAgreement :visible="showTermsAgreement"  @checked="onTermsAgreed" @close="onTermsNotAgreed" />
<!-- :checked="labModeChecked" -->
<!-- v-if="isLabAvailable" -->
      <div class="lab-toggle" v-if="isLabAvailable">
          <i v-html='svg.shopbot'></i>
          <label for="lab-mode">{{labModeLabel}}</label>
          <input
            type="checkbox"
            name="lab-mode"
            v-model="labModeChecked"
            
            @change="onLabModeToggle"
          />
          <div class="slider round"></div>
      </div>

    <div class='line'></div>
    <ul class='my-12'>
      <li>
        <div class="menu-title">
          <p class="title-text">{{ $t('加工条件設定') }}</p>
          <div class="tooltip">
            <i class="tooltip-img" alt="" width="20px" height="20px" v-html="svg.note"></i>
            <a
              href="https://docs.emarf.co/1515709244d280d8b95dcb6704aded91"
              target="_blank"
            >
              <span class="tooltip-text">{{ $t('詳細はこちら') }}</span>
            </a>
          </div>
        </div>
      </li>

      <template v-if="isLabMode">
        <li>
          <div class="select-box-wrapper">
            <label for="machine" class="w-100">{{ $t('機種') }}</label>

            <CustomMachineSelect
              v-model="selectedMachine"
              :machines="machines"
              :disabled="machineSelectDisabled"
              @input="onChangeMachine"
            />
          </div>
        </li>

        <li>
          <label>{{ $t('板サイズ') }}</label>
          <div class="col2">
            <div class="col2">
              <label for="material-x">X</label>
              <input
                v-model.number="properties.bin.width"
                type="number"
                name="material-x"
                id="material-x"
              />
            </div>
            <div class="col2">
              <label for="material-y">Y</label>
              <input
                v-model.number="properties.bin.depth"
                type="number"
                name="material-y"
                id="material-y"
              />
            </div>
          </div>
        </li>

        <li>
          <label>{{ $t('板厚 (mm)') }}</label>
          <input
            v-model="properties.thickness"
            type="number"
            disabled
          />
        </li>

        <li>
          <div class="select-box-wrapper" style="margin-top: 15px">
            <label for="mill-size" class="w-100">{{ $t('ミルサイズ') }}</label>
            <div class="select-box">
              <select v-model="properties.millSize" name="mill-size" id="mill-size">
                <option v-for="ms in filteredMillSizes" :value="ms.value" :key="ms.name">
                  {{ $t(ms.name) }}
                </option>
              </select>
              <i v-html="svg.caret"></i>
            </div>
          </div>
        </li>
        <!-- チェックボタン -->

        <li>
          <div class="select-box-wrapper" style="margin-top: 15px" v-if="!isBeginnerUser">
            <label for="setting-choices" class="w-100">{{ $t('設定') }}</label>
            <div class="select-box">
              <select v-model="selectedSetting" name="setting-choices" @change="applySetting">
                <option value="default">{{ $t('デフォルト設定を適用') }}</option>
                <option value="konishi">{{ $t('ggo設定を適用') }}</option>
                <option value="custom">{{ $t('カスタム設定') }}</option>
              </select>
              <i v-html="svg.caret"></i>
            </div>
          </div>
        </li>


        <div class="button-container" v-if="!isBeginnerUser">
          <input
          type="file"
          ref="fileInput"
          style="display: none"
          accept=".ems" 
          @change="onFileSelected"
        />
          <button
          class='button load-save'
          @click="handleSaveSettings()"
        >
          <span>{{ $t('設定保存') }}</span>
        </button>
        <button
          class='button load-save'
          @click="handleLoadSettings()"
        >
          <span>{{ $t('設定ロード') }}</span>
        </button>
        </div>


          <div class="advanced-toggle" v-if="!isBeginnerUser">
            <label for="is-advanced">{{ $t('高度な設定') }}</label>
            <input
              type="checkbox"
              name="is-advanced"
              id="is-advanced"
              v-model="isAdvanced"
              :disabled = "isBeginnerUser"
            />
            <div class="toggle-btn"></div>
          </div>

        <ul class="tab-wrapper">
          <li
          v-for="tab in tabs"
          :key="tab.id"
          :class="{tabselected: currentTab === tab.id}"
          class="tab"
          @click="selectTab(tab.id)"
        >{{ $t(tab.title) }}
        </li>
        </ul>
        <li v-show="currentTab === 1" class="tab-contents">
          <label>{{ $t('移動スピード (mm/sec)') }}</label>
          <div class="col2-fixed">
            <div>
              <label for="xy-speed">XY</label>
              <input
                v-model.number="properties.xySpeed"
                type="number"
                name="xy-speed"
                id="xy-speed"
                min="1"
                class="w-60"
                :disabled = "isBeginnerUser"
              />
            </div>
            <div>
              <label for="z-speed">Z</label>
              <input
                v-model.number="properties.zSpeed"
                type="number"
                name="z-speed"
                id="z-speed"
                min="1"
                class="w-60"
                :disabled = "isBeginnerUser"
              />
            </div>
          </div>

          <div v-if="isAdvanced">

            <label for="rotation-speed" class="w-100">{{ $t('回転スピード (rotate/sec)') }}</label>
            <div class="mb-16">

              <input
                v-model.number="properties.rotationSpeed"
                type="number"
                name="rotation-speed"
                id="rotation-speed"
                min="1"
              />
            </div>
            <label>{{ $t('Jogスピード (mm/sec)') }}</label>
            <div class="col2-fixed">
              <div>
                <label for="jog-speed">XY</label>
                <input
                  v-model.number="properties.jogSpeed"
                  type="number"
                  name="jog-speed"
                  id="jog-speed"
                  min="1"
                  max="500"
                  class="w-60"
                />
              </div>
            </div>

            <div class='separator'></div>
            <div class="selection-toggle my-8">
              <label class="m-0">{{ $t('仕上げスピード変更') }}</label>
              <input
                type="checkbox"
                name="add-second-cut"
                id="add-second-cut"
                v-model="properties.changeSecondCutSpeed"
              />
              <div class="toggle-btn"></div>
            </div>
            <div v-if="properties.changeSecondCutSpeed">
              <label>{{ $t('仕上げパス移動スピード (mm/sec)') }}</label>
              <div class="col2-fixed">
                <div>
                  <label for="second-cut-xy-speed">XY</label>
                  <input
                    v-model.number="properties.secondCutXYSpeed"
                    type="number"
                    name="second-cut-xy-speed"
                    id="second-cut-xy-speed"
                    min="1"
                    class="w-60"
                  />
                </div>
                <div>
                  <label for="second-cut-z-speed">Z</label>
                  <input
                    v-model.number="properties.secondCutZSpeed"
                    type="number"
                    name="second-cut-z-speed"
                    id="second-cut-z-speed"
                    min="1"
                    class="w-60"
                  />
                </div>
              </div>
            </div>

          </div>

        </li>
        <li v-show="currentTab === 2" class="tab-contents">
          <label>{{ $t('パス深さ (mm)') }}</label>

          <div class="col3 mb-16">
            <label for="path-height" class="label-regular">{{ $t('通常パス') }}</label>
            <p v-if="isAdvanced">{{pathHeights.length>1 ? $t('1層目深さ') : ''}}</p>
            <button v-if="isAdvanced" @click="addPathHeight" :disabled="isPathHeightLimitReached"><i v-html='svg.plus'></i><span v-if="isPathHeightLimitReached">パス深さの合計が<br/>材料の厚みを超えてしまいます</span></button>
            <input
              v-model.number="pathHeights[0]"
              type="number"
              name="path-height"
              id="path-height"
              min="1"
              class="w-60"
              :disabled = "isBeginnerUser"
            />
          </div>
          <div v-if="isAdvanced" v-for="(height, index) in pathHeights.slice(1)" :key="index" class="col3 mb-16">
            <label for=""></label>
            <p>{{ $t('{n}層目深さ', { n: index+2 }) }}</p>
            <button @click="removePathHeight" v-if="pathHeights.length > 1"><i v-html='svg.minus'></i></button>
            <input
                v-model.number="pathHeights[index + 1]"
                type="number"
                min="1"
                class="w-60"
              />
          </div>
          <div class="col2 mb-16" v-if="isAdvanced">
            <label for="v-bit-path-height" class="label-regular">{{ $t('立体パス') }}</label>
              <input
                v-model.number="properties.vBitPathHeight"
                type="number"
                name="v-bit-path-height"
                id="v-bit-path-height"
                min="1"
                class="w-60"
              />
          </div>
          <div class="col2 mb-16">
            <label for="" class="label-regular">{{ $t('ポケット加工時のステップ (mm)') }}</label>
            <input
              v-model.number="properties.pocketStep"
              type="number"
              name="pocket-step"
              id="pocket-step"
              min="1"
              class="w-60"
              :disabled = "isBeginnerUser"
            />
          </div>
          <div class="col2 mb-16" v-if="isAdvanced">
            <label for="" class="label-regular">{{ $t('ポケット加工深さ(mm)') }}</label>
            <input
              v-model.number="properties.pocketPathHeight"
              type="number"
              name="pocket-path-height"
              id="pocket-path-height"
              min="1"
              class="w-60"
            />
          </div>
          <div class="col2 mb-32" v-if="isAdvanced">
            <label for="is-first-cut-cw" class="label-regular">{{ $t('パスの方向') }}</label>
            <!-- <input
              type="checkbox"
              name="is-first-cut-cw"
              id="is-first-cut-cw"
              v-model="properties.isFirstCutCW"
            /> -->
            <!-- <div class="toggle-btn"></div> -->
             <ul class="toggle-tab-wrapper">
              <li class="toggle-tab " :data-tab="properties.isFirstCutCW" @click="properties.isFirstCutCW = true">
                <i v-html='svg.downcut'></i>
                <span>{{ $t('ダウンカット') }}</span>
              </li>
              <li class="toggle-tab " :data-tab="!properties.isFirstCutCW" @click="properties.isFirstCutCW = false">
                <i v-html='svg.upcut'></i>
                <span>{{ $t('アップカット') }}</span>
              </li>
             </ul>
          </div>
          <div class="col2 mb-16" v-if="isAdvanced">
              <label for="first-cut-offste-value" class="label-regular">{{ $t('削り残しオフセット') }}</label>
                <input
                  v-model.number="properties.firstCutOffsetValue"
                  type="number"
                  name="first-cut-offste-value"
                  id="first-cut-offste-value"
                  min="0.01"
                  class="w-60"
                />
            </div>
            <div class="col2 mb-32 select-box-wrapper" v-if="isAdvanced">
            <label for="is-first-cut-cw" class="label-regular">{{ $t('オフセットする範囲') }}</label>
             <!-- <ul class="toggle-tab-wrapper">
              <li class="toggle-tab " :data-tab="properties.firstCutInPathOffset" @click="setOffsetDirection('inside')">
                <i v-html='svg.inside'></i>
                <span>内側</span>
              </li>
              <li class="toggle-tab " :data-tab="properties.firstCutOffset" @click="setOffsetDirection('outside')">
                <i v-html='svg.outside'></i>
                <span>外側</span>
              </li>
             </ul> -->
             <div class="select-box w-110">
              <select name='offset-area' id='offset-area' v-model="offsetArea"  @change='handleOffsetAreaChange'>
                <option value='nooffset'>{{ $t('無し') }}</option>
                <option value='both'>{{ $t('外周と内周') }}</option>
                <option value='outside'>{{ $t('外周のみ') }}</option>
                <option value='inside'>{{ $t('内周のみ') }}</option>                
              </select>
              <i v-html='svg.caret'></i>
            </div>
          </div>

          <div v-if="isAdvanced">

            <div class='separator'></div>
            <div class="selection-toggle my-8">

              <label class="m-0">{{ $t('仕上げパスを追加') }}</label>
              <input
                type="checkbox"
                name="add-second-cut"
                id="add-second-cut"
                v-model="properties.addSecondCut"
              />
              <div class="toggle-btn"></div>

            </div>

            <div class="col3 mb-16" v-if="properties.addSecondCut">
              <label for="second path-height" class="label-regular">{{ $t('仕上げパス深さ') }}</label>
              <p >{{pathHeightsSecond.length>1 ? $t('1層目深さ') : ''}}</p>
              <button @click="addPathHeightSecond" :disabled="isPathHeightSecondLimitReached"><i v-html='svg.plus'></i><span v-if="isPathHeightSecondLimitReached">パス深さの合計が<br/>材料の厚みを超えてしまいます</span></button>
                <input
                  v-model.number="pathHeightsSecond[0]"
                  type="number"
                  name="second path-height"
                  id="second path-height"
                  min="1"
                  class="w-60"                  
                />
            </div>
            <div v-if="isAdvanced" v-for="(height, index) in pathHeightsSecond.slice(1)" :key="index" class="col3 mb-16">
              <label for=""></label>
              <p>{{ $t('{n}層目深さ', { n: index+2 }) }}</p>
              <button @click="removePathHeightSecond" v-if="pathHeightsSecond.length > 1"><i v-html='svg.minus'></i></button>
              <input
                  v-model.number="pathHeightsSecond[index + 1]"
                  type="number"
                  min="1"
                  class="w-60"
                />
            </div>

            <div class="col2 mb-32" v-if="properties.addSecondCut">
              <label for="is-second-cut-cw" class="label-regular">{{ $t('仕上げパスの方向') }}</label>
              <ul class="toggle-tab-wrapper">
                <li class="toggle-tab " :data-tab="properties.isSecondCutCW" @click="properties.isSecondCutCW = true">
                  <i v-html='svg.downcut'></i>
                  <span>{{ $t('ダウンカット') }}</span>
                </li>
                <li class="toggle-tab " :data-tab="!properties.isSecondCutCW" @click="properties.isSecondCutCW = false">
                  <i v-html='svg.upcut'></i>
                  <span>{{ $t('アップカット') }}</span>
                </li>
              </ul>
            </div>

            <div v-if="properties.hasHolePoints">
              <div class='separator'></div>
              <label>{{ $t('穴あけ加工') }}</label>
              <div class="col2 mb-16">
                <label for="hole-diameter" class="label-regular">{{ $t('穴直径') }}</label>
                  <input
                    v-model.number="properties.holeDiameter"
                    type="number"
                    name="hole-diameter"
                    id="hole-diameter"
                    min="1"
                    class="w-60"
                  />
              </div>
              <div class="col2 mb-16">
                <label for="hole-path-height" class="label-regular">{{ $t('穴パス深さ') }}</label>
                  <input
                    v-model.number="properties.holePathHeight"
                    type="number"
                    name="hole-path-height"
                    id="hole-path-height"
                    min="1"
                    class="w-60"
                  />
              </div>
              <div class="col2 mb-16">
                <label for="hole-rotation" class="label-regular">{{ $t('回転数') }}</label>
                  <input
                    v-model.number="properties.holeRotation"
                    type="number"
                    name="hole-rotation"
                    id="hole-rotation"
                    min="1"
                    class="w-60"
                  />
              </div>
            </div>

          

            <div class='separator'></div>
            <div class="selection-toggle my-8">
              <label class="m-0">{{ $t('cut.sbpとvbit.sbpを統合して作成') }}</label>
              <input
                type="checkbox"
                name="combine-cut-and-vbit"
                id="combine-cut-and-vbit"
                v-model="properties.exportCutWithVbit"
              />
              <div class="toggle-btn"></div>
            </div>

          </div>

        </li>
        <li v-show="currentTab === 3" class="tab-contents">
          <div class="col2 mb-32">
            <label for="is-triangular-tab">{{ $t('タブ種類') }}</label>
            <ul class="toggle-tab-wrapper">
                <li class="toggle-tab " :class="{disabled: isBeginnerUser}" :data-tab="!properties.isTriangularTab && !properties.isTrimmerHole" @click="handleTabTypeChange('rect')">
                  <i v-html='svg.tabRect'></i>
                  <span>{{ $t('通常タブ') }}</span>
                </li>
                <li class="toggle-tab " :class="{disabled: isBeginnerUser}" :data-tab="properties.isTriangularTab && !properties.isTrimmerHole" @click="handleTabTypeChange('triangle')">
                  <i v-html='svg.tabTriangle'></i>
                  <span>{{ $t('三角タブ') }}</span>
                </li>
                <li class="toggle-tab " :class="{disabled: isBeginnerUser}" :data-tab="properties.isTrimmerHole" @click="handleTabTypeChange('trimmer')">
                  <i v-html='svg.tabTrimmer'></i>
                  <span>{{ $t('トリマー') }}</span>
                </li>
              </ul>
          </div>

          <div class="col2 mb-16" v-if="properties.isTrimmerHole">
            <label for="trimmer-offset" class="label-regular">{{ $t('トリマーオフセット') }}</label>
              <input
                v-model.number="properties.trimmerHoleOffset"
                type="number"
                name="trimmer-offset"
                id="trimmer-offset"
                min="0"
                class="w-60"
              />
          </div>

          <div v-if="!properties.isTrimmerHole">
          <label >{{ $t('タブサイズ (mm)') }}</label>
          <div class="col2-fixed">
            <div >
              <label for="tab-width" class="label-regular">{{ $t('幅') }}</label>
              <input
                v-model.number="properties.tabWidth"
                type="number"
                name="tab-width"
                id="tab-width"
                min="1"
                class="w-60"
                :disabled = "isBeginnerUser"
              />
            </div>
            <div >
              <label for="tab-height" class="label-regular">{{ $t('高さ') }}</label>
              <input
                v-model.number="properties.tabHeight"
                type="number"
                name="tab-height"
                id="tab-height"
                min="1"
                class="w-60"
                :disabled = "isBeginnerUser"
              />
            </div>
          </div>
        </div>

        </li>

        <li v-show="currentTab === 4" class="tab-contents">

          <div class="selection-toggle my-8" :class="{ disabled: isBeginnerUser }">
            <label class="m-0">{{ $t('XY基準オフセット (mm)') }}</label>
              <input
                type="checkbox"
                name="xy-offset"
                id="xy-offset"
                v-model="properties.offsetXYValue"
                :disabled = "isBeginnerUser"
              />
          <div class="toggle-btn"></div>
          </div>

          <div class="col2-fixed" v-if="properties.offsetXYValue">
            <div >
              <label for="x-offset" class="label-regular">X:</label>
              <input
                v-model.number="properties.xOffset"
                type="number"
                name="x-offset"
                id="x-offset"
                min="0"
                class="w-60"
              />
            </div>
            <div >
              <label for="y-offset" class="label-regular">Y:</label>
              <input
                v-model.number="properties.yOffset"
                type="number"
                name="y-offset"
                id="y-offset"
                min="0"
                class="w-60"
              />
            </div>
          </div>

          <div class="selection-toggle my-8"  :class="{ disabled: isBeginnerUser }">
            <label class="m-0">{{ $t('ホームの位置設定 (mm)') }}</label>
              <input
                type="checkbox"
                name="xy-home"
                id="xy-home"
                v-model="properties.setHomeXYValue"
                :disabled = "isBeginnerUser"
              />
          <div class="toggle-btn"></div>
          </div>

          <div class="col2-fixed" v-if="properties.setHomeXYValue">
            <div >
              <label for="x-home" class="label-regular">X:</label>
              <input
                v-model.number="properties.xHome"
                type="number"
                name="x-home"
                id="x-home"
                min="0"
                class="w-60"
              />
            </div>
            <div >
              <label for="y-home" class="label-regular">Y:</label>
              <input
                v-model.number="properties.yHome"
                type="number"
                name="y-home"
                id="y-home"
                min="0"
                class="w-60"
              />
            </div>
          </div>

        </li>

        <!-- <li>
          <button @click="toggleDetailSetting">詳細設定</button>
          <div v-if="isDetailSettingVisible">
          </div>
        </li> -->
      </template>
      <template v-else>
        <li>
          <div class='select-box-wrapper'>
            <label for='material'>{{ $t('材種') }}</label>
            <div class="select-box">
              <select name='material' id='material' v-model='properties.material_id' @change='onChangeMaterial'>
                <option v-for='material in materials' :value='material.id' :key='material.id'>{{ $t(material.name) }}</option>
              </select>
              <i v-html='svg.caret'></i>
            </div>
          </div>
        </li>

        <li>
          <label>{{ $t('板厚 (mm)') }}</label>
          <input
            v-model="properties.thickness"
            type="number"
            disabled
          />
        </li>

        <li>
          <div class='select-box-wrapper'>
            <label for='bin-size'>{{ $t('板のサイズ') }}</label>
            <div class="select-box">
              <select
                v-model="properties.material_assortment_id"
                name='bin-size'
                id='bins-size'
                :disabled="material_assortments_candidates.length <= 1"
              >
                <option
                  v-for='ma in material_assortments_candidates'
                  :value='ma.id'
                  :key='ma.id'
                >{{ ma.width }} x {{ ma.height }}</option>
              </select>
              <i v-html='svg.caret'></i>
            </div>
          </div>
        </li>

        <li>
          <div class='small-notes'>
            <i v-html='svg.note'></i>
            <a
              class=''
              href='https://docs.emarf.co/1515709244d280c4a3effd77db4e4d9d'
              target='_blank'
              data-ga-click-event="材種の詳細について"
            >{{ $t('材種の詳細について') }}</a>
          </div>
        </li>
        <li>
          <div class='small-notes'>
            <i v-html='svg.note'></i>
            <a
              class=''
              href='https://docs.emarf.co/1515709244d280c4a3effd77db4e4d9d#17a5709244d280fea9cdc457758fea28'
              target='_blank'
              data-ga-click-event="ご希望の材料がない場合"
            >{{ $t('ご希望の材料がない場合') }}</a>
          </div>
        </li>

        <li>
          <div class='select-box-wrapper'>
            <label for='finish-option'>{{ $t('仕上げ') }}</label>
            <div class="select-box">
              <select v-model='finishOption' name='finish-option' id='finish-option'>
                <option v-for='(op, idx) in finishOptions' :key='idx' :value='idx'>{{ $t(op) }}</option>
              </select>
              <i v-html='svg.caret'></i>
            </div>
          </div>
        </li>

        <li>
          <div class='select-box-wrapper'>
            <label for='bezel'>{{ $t('面取り') }}</label>
            <div class="select-box">
              <select v-model="bezelOption" name='bezel' id='bezel'>
                <option v-for='(bezel, index) in bezelOptions' :value='index' :key='index'>{{ $t(bezel.key) }}</option>
              </select>
              <i v-html='svg.caret'></i>
            </div>
          </div>
        </li>

        <!-- <li>
          <div class='select-box-wrapper'>
            <label for='paints'>塗装</label>
            <select v-model="paintOption" name='paints' id='paints'>
              <option
                v-for='(paint, index) in paintOptions'
                :value='paint.id'
                :key='index'
              >{{ paint.name }}</option>
            </select>
            <i v-html='svg.caret'></i>
          </div>
        </li>

        <li>
          <p class="select-note">※塗装には最低発注枚数があります</p>
        </li> -->

        <li class=''>
          <div class='small-notes'>
            <i v-html='svg.note'></i>
            <a
              class="one-row"
              href='https://docs.emarf.co/1525709244d2806dac95d67d108b9b5c'
              target='_blank'
              data-ga-click-event="仕上げ・面取り・塗装の詳細について"
            >{{ $t('仕上げ・面取り・塗装について') }}</a>
          </div>
        </li>
      </template>
    </ul>

    <div class='line'></div>

    <ul class='my-12'>
      <li>
        <div class="menu-title">
          <p class="title-text">{{ $t('フィレット設定') }}</p>
          <div class="tooltip">
            <i class="tooltip-img" alt="" width="20px" height="20px" v-html="svg.note"></i>
            <a
              href="https://docs.emarf.co/1515709244d2809ea9a9c8a349bdcc16"
              target="_blank"
            >
              <span class="tooltip-text">{{ $t('フィレットについてはこちら') }}</span>
            </a>
          </div>
        </div>
      </li>
      <li>
        <div class='select-box-wrapper'>
          <label for='fillet-type'>{{ $t('フィレットタイプ') }}</label>
          <div class="select-box">
            <select
              ref="filletSelector"
              name='fillet-type'
              id='fillet-type'
              v-model='selectedFilletType'
              @change="onChangeFilletType"
            >
              <option
                v-for='(value, name) in filletTypes'
                :value='value'
                :key='name'
              >{{ $t(filletTypeLabels[value]) }}</option>
            </select>
          </div>
        </div>
      </li>
      <!-- <li>
        <button class='button' @click.prevent.stop='$emit("all")'>
          <i v-html='svg.generate'></i><span>全箇所に適用</span>
        </button>
      </li> -->
      <li>
        <button class='button' @click.prevent.stop='$emit("undo")'>
          <i v-html='svg.undo'></i><span>{{ $t('元に戻す') }}</span>
        </button>
      </li>
      <li>
        <button class='button' @click.prevent.stop='$emit("redo")'>
          <i v-html='svg.redo'></i><span>{{ $t('やり直す') }}</span>
        </button>
      </li>
      <li>
        <button class='button' @click.prevent.stop='$emit("reset")'>
          <i v-html='svg.reset'></i><span>{{ $t('リセット') }}</span>
        </button>
      </li>
      <li class=''>
        <div class='notes'>
          <i v-html='svg.note'></i>
          <a
            href='https://docs.emarf.co/1515709244d280d8b95dcb6704aded91#1525709244d28083915cd1fbed759928'
            target='_blank'
            data-ga-click-event="操作方法について"
          >{{ $t('操作方法について') }}</a>
        </div>
      </li>
    </ul>

    <div class='line'></div>



    <ul class='my-12'>
      <li v-if="isLabMode" class="selection-toggle my-8" >
        <label class="m-0">{{ $t('新バージョンを利用') }}</label>
        <input
          type="checkbox"
          name="use-new-version"
          id="use-new-version"
          v-model="localUseNewApiVersion"
          @change="onNewApiVersionToggle"
        />
        <div class="toggle-btn"></div>
      </li>

      <li v-if="!properties.isCustomSend && !properties.hasScrew">
        <button
          class='button step'
          @click.prevent.stop='$emit("confirm", "next")'
        >
          <span>{{ $t('配置設定へ') }}</span>
        </button>
      </li>

      <li v-if="!properties.isCustomSend && !properties.hasScrew">
        <button
          class='button step tooltipped tooltipped-n'
          :aria-label="$t('部材の配置を自動で計算します')"
          @click.prevent.stop='$emit("confirm", "skip")'
        >
          <span>{{ $t('配置設定をスキップ') }}</span>
        </button>
      </li>

      <li v-if="isLabMode && (properties.isCustomSend || properties.hasScrew)">
        <button
          class='button step'
          @click.prevent.stop='$emit("nonesting")'
        >
          <span>{{ $t('配置なしで加工へ') }}</span>
        </button>
      </li>

      <li>
        <button
          class='button step back'
          v-if="toolPathExists"
          @click.prevent.stop='$emit("cancel")'
        >
          <span>{{ $t('キャンセル') }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

import filletDogBone from '@/assets/images/fillet/dogBone.jpg';
import filletTypeA from '@/assets/images/fillet/typeA.jpg';
import filletTypeB from '@/assets/images/fillet/typeB.jpg';
import filletTypeH from '@/assets/images/fillet/typeH.jpg';
import filletTypeI from '@/assets/images/fillet/typeI.jpg';
import svgGenerate from '@/assets/images/plugin/generate.svg';
import svgNote from '@/assets/images/plugin/note.svg';
import svgRedo from '@/assets/images/plugin/redo.svg';
import svgReset from '@/assets/images/plugin/reset.svg';
import svgSelectBoxCaret from '@/assets/images/plugin/select_box_caret.svg';
import svgShopbot from '@/assets/images/plugin/shopbot.svg';
import svgUndo from '@/assets/images/plugin/undo.svg';
import svgPlus from '@/assets/images/plugin/plus.svg';
import svgMinus from '@/assets/images/plugin/minus.svg';
import svgUpcut from '@/assets/images/plugin/upcut.svg';
import svgDowncut from '@/assets/images/plugin/downcut.svg';
import svgInside from '@/assets/images/plugin/inside.svg';
import svgOutside from '@/assets/images/plugin/outside.svg';
import svgMore from '@/assets/images/plugin/more.svg';
import svgTabRect from '@/assets/images/plugin/tab-rect.svg';
import svgTabTriangle from '@/assets/images/plugin/tab-triangle.svg';
import svgTabTrimmer from '@/assets/images/plugin/tab-trimmer.svg';
import { FilletTypes } from '@/assets/javascripts/fillet/fillet_utils';
import CustomMachineSelect from '../CustomMachineSelect.vue';
import { Auth } from 'aws-amplify';
import TermsAgreement from '../TermsAgreement.vue';
import TermsPopup from '../TermsPopup.vue';
import {Cache} from '@/assets/javascripts/Cache';

var beginnerEmails = ['vuild.emarflab@gmail.com','@ed.tus.ac.jp', '@rs.tus.ac.jp'];
var expertEmails = ['@vuild.co.jp'];

export default {
  name: 'PluginStep1Menu',
  components: {
    CustomMachineSelect,
    TermsAgreement,
    TermsPopup,
  },
  props: {
    properties: Object,
    materials: Array,
    material_assortments: Array,
    paintOptions: Array,
    limit: {
      type: Number,
      default: 10
    },
    error: {
      type: Boolean,
      default: false
    },
    toolPathExists: {
      type: Boolean,
      default: false
    },
    isLoading: Boolean,
    isLabAvailable: Boolean,
    isLabMode: Boolean,
    toggleLabMode: Function,
    useNewApiVersion: Boolean
  },

  watch: {
    'properties.material_id': function () {
      this.updateMaterialAssortmentsCandidates();
    },
    'properties.thickness': function () {
      this.updateMaterialAssortmentsCandidates();
    },
    'properties.millSize': function (value) {
      this.updatePathHeightByMillSize(value);
      this.$emit('changeMillSize', value);
    },
    selectedMachine: function () {
      this.updatePathHeightByMillSize();
    },
    isLoading: function (current) {
      if (!current) {
        this.updateMaterialAssortmentsCandidates();
      }
    },
    material_assortments: function () {
      this.updateMaterialAssortmentsCandidates();
    },
    pathHeights: function () {
      this.updateFirstCutPathHeights();      
    },
    pathHeightsSecond: function() {
      this.updateSecondCutPathHeights();
    },
    isAdvanced: function (newValue) {
      // Only reset pathHeights when toggling advanced mode and there are multiple layers
      // if (this.pathHeights.length > 1) {
      //   const firstElement = this.pathHeights[0];
      //   this.pathHeights = [firstElement];
      // }
    },
    isBeginnerUser(newVal) {
      this.properties.isBeginner = newVal;
    },
    isExpertUser(newVal) {
      this.properties.isExpert = newVal;
    },
    useNewApiVersion(newVal) {
      this.localUseNewApiVersion = newVal;
    },
  },

  data () {
    return {
      showTermsAgreement: false,
      labModeChecked: this.isLabMode,
      localUseNewApiVersion: this.useNewApiVersion,
      currentUserEmail: null,
      isBeginnerUser: false,
      isExpertUser: false,
      svg: {
        caret: svgSelectBoxCaret,
        note: svgNote,
        generate: svgGenerate,
        undo: svgUndo,
        redo: svgRedo,
        reset: svgReset,
        shopbot: svgShopbot,
        plus: svgPlus,
        minus: svgMinus,
        upcut: svgUpcut,
        downcut: svgDowncut,
        inside: svgInside,
        outside: svgOutside,
        more: svgMore,
        tabRect: svgTabRect,
        tabTriangle: svgTabTriangle,
        tabTrimmer: svgTabTrimmer,

      },
      finishOptions: [
        '-', 'バリ取り', 'バリ取り + 表面研磨'
      ],
      bins: [],
      material_assortments_candidates: [], // 選択されたmaterialに紐づいたmaterial_assortments
      bezelOptions: [
        { key: '-', value: false },
        { key: '面取りあり（糸面取り）', value: true },
        { key: '面取りあり（R面取り6mm）', value: true },
        { key: '面取りあり（R面取り9mm）', value: true }
      ],
      filletTypes: FilletTypes,
      filletTypeLabels: {
        [FilletTypes.None]: 'なし',
        [FilletTypes.DogBone]: 'ドッグボーン',
        [FilletTypes.Clockwise]: 'A型',
        [FilletTypes.CounterClockwise]: 'B型',
        [FilletTypes.I]: 'I型',
        [FilletTypes.H]: 'H型'
      },
      selectedMachine: this.$emarf.machines[0],
      selectedFilletType: FilletTypes.DogBone,
      millSizes: this.$emarf.millSizes,
      machines: this.$emarf.machines,
      isDetailSettingVisible: false,
      isAdvanced: false,
      selectedSetting: 'default',
      offsetArea:'nooffset',
      pathHeights: [this.properties.pathHeight],
      pathHeightsSecond: [this.properties.secondPathHeight],
      currentTab: 1,
      tabs: [
        { id: 1, title: '速さ' },
        { id: 2, title: 'パス設定' },
        { id: 3, title: 'タブ' },
        { id: 4, title: '軸'},
      ]
    };
  },

  created () {
    this.machines = this.$emarf.machines;
    this.selectedMachine = this.$emarf.machines[0];
  },

  computed: {
    filteredMillSizes() {
      if (this.isBeginnerUser) {
        return this.millSizes.filter(ms => 
          ms.value === 6.35 || ms.value === 12.7
        );
      }
      return this.millSizes;
    },
    isPathHeightLimitReached () {
      const totalPathHeight = this.pathHeights.reduce((sum, height) => sum + height, 0);
      return totalPathHeight >= this.properties.thickness;
    },
    isPathHeightSecondLimitReached() {
      const totalPathHeight = this.pathHeightsSecond.reduce((sum, height) => sum + height, 0);
      return totalPathHeight >= this.properties.thickness;
    },
    finishOption: {
      get () {
        if (this.properties.finish.burr && this.properties.finish.sanding) {
          return 2;
        } else if (this.properties.finish.burr) {
          return 1;
        }
        return 0;
      },
      set (v) {
        switch (v) {
          case 0:
            this.properties.finish.sanding = this.properties.finish.burr = false;
            break;
          case 1:
            this.properties.finish.burr = true;
            this.properties.finish.sanding = false;
            break;
          case 2:
            this.properties.finish.sanding = this.properties.finish.burr = true;
            break;
        }
      }
    },
    bezelOption: {
      get () {
        if (typeof this.properties.bezel === 'number') {
          return this.properties.bezel;
        } else {
          if (this.properties.bezel) {
            return 1;
          } else {
            return 0;
          }
        }
      },
      set (v) {
        this.properties.bezel = v;
      }
    },
    paintOption: {
      get () {
        return this.properties.paint_data.id;
      },
      set (v) {
        this.properties.paint_data = this.paintOptions.find(option => option.id == v);
      }
    },
    machineSelectDisabled () {
      return (this.properties.isCustomSend || this.properties.hasScrew) && this.properties.hasSheetSize;
    },
    labModeLabel() {
      if (this.isBeginnerUser) {
        return 'LAB MODE';
      } else if (this.isExpertUser) {
        return 'LAB MODE'
      } else {
        return 'FOR OWNERS';
      }
      
    }
  },

  mounted () {
    this.getCurrentUserEmail();
    this.updateMaterialAssortmentsCandidates();
    this.onChangeFilletType();
  },

  methods: {
    onLabModeToggle() {
      const termsAgreed = Cache.get('emarf_terms_checked');
      //let termsAgreed = localStorage.getItem('emarf_terms_checked')

      console.log('agreementShown', termsAgreed);
      if (!this.isLabMode) {

        if (!termsAgreed)
        {
          this.showTermsAgreement = true;
          //this.labModeChecked = false;
        }
        else {
          this.toggleLabMode();
        }

      } else {
        this.toggleLabMode();
      }
    },
    onNewApiVersionToggle() {
      this.$emit('changeApiVersion', this.localUseNewApiVersion);
    },
    onTermsAgreed() {
      this.showTermsAgreement = false;
      //localStorage.setItem('emarf_terms_checked', true);
      Cache.set('emarf_terms_checked', true);
      //this.labModeChecked = true;
      this.toggleLabMode();
    },
    onTermsNotAgreed() {
      this.showTermsAgreement = false;
      this.labModeChecked = false;
      console.log(this.isLabMode);
    },

    async getCurrentUserEmail() {
      try{
        const user = await Auth.currentAuthenticatedUser();
        if (user && user.attributes && user.attributes.email) {
          this.currentUserEmail = user.attributes.email;

          if (expertEmails.some(email => this.currentUserEmail.includes(email))) {
            this.isExpertUser = true;
          } else {
            this.isExpertUser = false;
          }

          if (beginnerEmails.some(email => this.currentUserEmail.includes(email))) {
            this.isBeginnerUser = true;
            this.isExpertUser = false;
          } else {
            this.isBeginnerUser = false;
          }

          
          //console.log('User email:', this.currentUserEmail);
          //console.log('Is Expert user:', this.isExpertUser);   
          //console.log('Is beginner user:', this.isBeginnerUser);         
        } else {
          //console.error('User email not found in attributes');          
        }
      } catch (error) {
        //console.error('Error fetching user email:', error);
      }
    },
    updateMaterialAssortmentsCandidates () {
      const { material_id, thickness } = this.properties;
      this.material_assortments_candidates = this.material_assortments.filter(assortment => {
        return (assortment.material_id === material_id) && (assortment.thickness === thickness);
      });
      const found = this.material_assortments_candidates.find(ma => ma.id === this.properties.material_assortment_id);
      if (found === undefined && this.material_assortments_candidates.length > 0) {
        this.properties.material_assortment_id = this.material_assortments_candidates[0].id;
      }
    },

    updatePathHeightByMillSize (millSize) {
      const ms = millSize || this.properties.millSize;
      if (ms >= 10 && ['desktop-max', 'desktop'].includes(this.selectedMachine)) {
        this.properties.pathHeight = Math.round(ms * 0.65);
      } else {
        this.properties.pathHeight = ms;
      }
    },

    updateFirstCutPathHeights () {
      if (this.pathHeights && this.pathHeights.length > 0) {
        this.properties.pathHeight = this.pathHeights[0];
      }
      this.properties.firstCutPathHeightList = this.pathHeights;
    },
    updateSecondCutPathHeights () {
      if (this.pathHeightsSecond && this.pathHeightsSecond.length > 0) {
        this.properties.secondPathHeight = this.pathHeightsSecond[0];
      }
      this.properties.secondCutPathHeightList = this.pathHeightsSecond;
    },

    onChangeMaterial () {
      this.updateMaterialAssortmentsCandidates();
    },

    onChangeFilletType () {
      const selector = this.$refs.filletSelector;
      let url = filletDogBone;
      switch (this.selectedFilletType) {
        case FilletTypes.None:
          url = '';
          break;
        case FilletTypes.Clockwise:
          url = filletTypeA;
          break;
        case FilletTypes.CounterClockwise:
          url = filletTypeB;
          break;
        case FilletTypes.I:
          url = filletTypeI;
          break;
        case FilletTypes.H:
          url = filletTypeH;
          break;
      }
      selector.style.background = `url("${url}") no-repeat right center transparent`;
      this.$emit('selectFilletType', this.selectedFilletType);
    },

    onChangeMachine (value) {
      this.$emit('changeMachine', value);
    },

    toggleDetailSetting () {
      this.isDetailSettingVisible = !this.isDetailSettingVisible;
    },
    toggleAdvanced () {
      this.isAdvanced = !this.isAdvanced;
    },
    selectTab (id) {
      this.currentTab = id;
    },
    applySetting() {
      if (this.selectedSetting === 'default') {
        this.setDefaultSettings();
      } else if (this.selectedSetting === 'konishi') {
        this.setKonishiSettings();
      }
    },
    setOffsetDirection (direction) {
      this.offsetArea = direction;
      if (direction == 'both') {
        this.properties.firstCutInPathOffset = true;
        this.properties.firstCutOffset = true;
      } else if (direction == 'outside') {
        this.properties.firstCutInPathOffset = false;
        this.properties.firstCutOffset = true;
      } else if (direction == 'inside') {
        this.properties.firstCutInPathOffset = true;
        this.properties.firstCutOffset = false;
      } else if (direction == 'nooffset') {
        this.properties.firstCutInPathOffset = false;
        this.properties.firstCutOffset = false;
      }
    },
    setKonishiSettings () {
      if (this.isBeginnerUser) {
        this.selectedSetting = 'default'        
        alert('この設定は上級者向けです。');
        return;
      }
      this.isAdvanced = true;
      this.properties.isTriangularTab = false;
      this.properties.isTrimmerHole = true;
      this.properties.trimmerHoleOffset = 0.25;
      this.properties.pathHeight = 6.35;
      this.properties.pocketPathHeight = 6;
      this.properties.isFirstCutCW = false;
      this.properties.firstCutOffset = true;        
      this.properties.firstCutInPathOffset = false;
      this.properties.firstCutOffsetValue = 0.25;
      this.properties.addSecondCut = true;
      this.properties.vBitPathHeight = 6.325;

      this.properties.changeSecondCutSpeed = false;
      this.properties.secondCutXYSpeed = 42;
      this.properties.secondCutZSpeed = 25;

      this.properties.secondPathHeight = 22;
      this.pathHeightsSecond = [22]
      this.properties.secondCutPathHeightList = this.pathHeightsSecond;
      this.pathHeights = [5.75, 5.75, 5.75, 5.75];
      this.properties.firstCutPathHeightList = this.pathHeights;

      this.properties.xySpeed = 50;
      this.properties.rotationSpeed = 12000;
      this.properties.jogSpeed = 250;
      this.properties.tabHeight = 7;
      this.properties.tabWidth = 25;
      this.properties.exportCutWithVbit = true;

      this.properties.offsetXYValue = true;
      this.properties.xOffset = 0;
      this.properties.yOffset = 120;
      this.properties.setHomeXYValue = true;
      this.properties.xHome = 2300;
      this.properties.yHome = 120;

      this.properties.holeDiameter  = 14;
      this.properties.holePathHeight = 6;
      this.properties.holeRotation = 6000;
      this.properties.millSize = 12.7;
      this.setOffsetDirection('outside')


    },
    setDefaultSettings () {
      this.isAdvanced = false;
      this.properties.isTriangularTab = false;
      this.properties.isTrimmerHole = false;
      this.properties.addSecondCut = false;
      this.properties.secondPathHeight = this.properties.thickness;
      this.properties.isFirstCutCW = false;
      this.properties.pathHeight = 6.35;
      this.properties.firstCutOffset = false;
      this.properties.firstCutInPathOffset = false;
      this.properties.firstCutOffsetValue = 0.2;
      this.properties.isFirstCutCW = false;      
      this.pathHeights = [this.properties.pathHeight];
      this.properties.firstCutPathHeightList = this.pathHeights;
      this.properties.pocketPathHeight = 6.35;
      this.properties.jogSpeed = 100;
      this.properties.tabHeight = 8;
      this.properties.tabWidth = 10;
      this.properties.xySpeed = 75;
      this.properties.rotationSpeed = 18000;
      this.properties.exportCutWithVbit = false;
      this.properties.vBitPathHeight = 3;

      this.properties.changeSecondCutSpeed = false;

      this.setOffsetDirection("nooffset");
      this.properties.offsetXYValue = false;
      this.properties.xOffset = 0;
      this.properties.yOffset = 0;
      this.properties.setHomeXYValue = false;
      this.properties.xHome = 0;
      this.properties.yHome = 0;

    },
    addPathHeight () {
      this.pathHeights.push(this.properties.pathHeight);
    },
    removePathHeight () {
      if (this.pathHeights.length > 1) {
        this.pathHeights.pop();
      }
    },

    addPathHeightSecond () {
      this.pathHeightsSecond.push(this.properties.secondPathHeight);
    },
    removePathHeightSecond () {
      if (this.pathHeightsSecond.length > 1) {
        this.pathHeightsSecond.pop();
      }
    },


    handleTabTypeChange(tabType) {
      if (tabType == 'rect') {
        this.properties.isTriangularTab = false;
        this.properties.isTrimmerHole = false;
      } else if (tabType == 'triangle') {
        this.properties.isTriangularTab = true;
        this.properties.isTrimmerHole = false;
      } else if (tabType == 'trimmer') {
        this.properties.isTrimmerHole = true;
        this.properties.isTriangularTab = false
      }
    },

    handleOffsetAreaChange (event) {
      const value = event.target.value;
      this.setOffsetDirection(value);
      // if (value === 'both') {
      //   this.properties.firstCutInPathOffset = true;
      //   this.properties.firstCutOffset = true;
      // } else if (value === 'outside') {
      //   this.properties.firstCutInPathOffset = false;
      //   this.properties.firstCutOffset = true;
      // } else if (value === 'inside') {
      //   this.properties.firstCutInPathOffset = true;
      //   this.properties.firstCutOffset = false;
      // } else if (value === 'nooffset') {
      //   this.properties.firstCutInPathOffset = false;
      //   this.properties.firstCutOffset = false;
      // }
    },

    handleSaveSettings() {

      const options = {
        isAdvanced: this.isAdvanced,
        pathHeights: this.pathHeights,
        pathHeightsSecond: this.pathHeightsSecond,
        offsetArea: this.offsetArea,
      }

      // Filter out properties that are in unloadSettings
      const filteredProperties = Object.keys(this.properties)
        .filter((key) => !this.properties.unloadSettings.includes(key))
        .reduce((obj, key) => {
          obj[key] = this.properties[key];
          return obj;
        }, {});          

      const finalSettings = {
        properties: filteredProperties,
        options: options
      }

      console.log("SAVE SETTINGS: ", finalSettings);

      const jsonString = JSON.stringify(finalSettings, null, 2);
      const blob = new Blob([jsonString], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'emarf_settings.ems';
      link.click();
      URL.revokeObjectURL(url);
    },

    handleLoadSettings() {
      this.$refs.fileInput.click();
    },

    onFileSelected(event) {
      const file = event.target.files[0];
      if (file) {
        if (!file.name.endsWith('.ems')) {
          alert('.ems ファイルを選択してください。');
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            this.selectedSetting = 'custom';
            const fileContent = JSON.parse(e.target.result);

            const jsproperties = fileContent.properties;
            const options = fileContent.options;

            // Update options dynamically
            if (options) {
              Object.keys(options).forEach((key) => {

                if (key === 'isAdvanced' && options[key] === true && this.isBeginnerUser) {
                  this.selectedSetting = 'default'        
                  alert('この設定は上級者向けです。');
                  return;
                } 
                if (this.hasOwnProperty(key)) {
                  this[key] = options[key];
                }
              });
            }

            //console.log("UNLOAD SETTINGS: ", this.properties.unloadSettings);
            if (jsproperties) {
              Object.keys(jsproperties).forEach((key) => {                
              if (this.properties.hasOwnProperty(key) && (!this.properties.unloadSettings.includes(key))) {

                this.properties[key] = jsproperties[key];
              }
            });
            }
            

          } catch (error) {
            console.error("Error parsing JSON:");
            this.selectedSetting = 'default'    
            // Handle the error (e.g., show an error message)
          }
          
          

        };
        reader.readAsText(file); 
    
      }
    }

  }
};

</script>

<style lang="scss" scoped>

#fillet-type {
  background-color: #eee !important;
  transition: all .2s ease-out;
  height: 50px;
}

.button.step {
  line-height: 1rem !important;
}

.button-container {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}
.button.load-save {
  flex: 1;
  line-height: 1rem !important;
  height: 20px;
}
.mb-16{
  margin-bottom: 1rem;
}
.mb-32{
  margin-bottom: 2rem;
}
.w-100 {
  width: 100% !important;
}
.w-110{
  width: 110px;
}
.icon-30{
  position: relative;
          height: 30px;
          pointer-events: none;

          svg {
            position: absolute;
            right: 0px;

            width: 30px;
            height: 30px;

            stroke-width: 0;
          }
}

.col2-fixed{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap:16px;
  margin:0 0 16px 0;
  div{
    label{
      margin-bottom: 0!important;
      font-size: 10px;
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.w-60{
  max-width: 60px;
}

.my-12 > li.selection-toggle.my-8 {
  width: calc(100% - 40px);
  justify-content: space-between;
  margin-left: 20px;
  margin-right: 20px;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/components/plugin/PluginStep1Menu.vue